import React, { useState, useEffect } from "react";
// Assuming TypewriterText is not needed for IndexIslamicGuide's title,
// but if it were, you would need to import it.
// For now, I'll keep the title static as "Table of Contents" and "Bitcoin and Islamic Finance".
import { Link } from "react-router-dom";
import TypewriterText from "../components/TypeWriterText";
const pages = [
  { title: " Curators Foreword", path: "/foreword-guide" },

  {
    title: "Day 61: Bitcoin as al-māl(money)",
    path: "/islamicguide-61",
  },
  {
    title: "Day 62: The Qīmah of Bitcoin: An Inquiry into Its Worth",
    path: "/islamicguide-62",
  },
  {
    title:
      "Day 63: Decentralized Money: A Return to Islamic Financial Principles",
    path: "/islamicguide-63",
  },
  {
    title:
      "Day 64: Bitcoin's Pseudonymity: A Modern Application of Islamic Privacy",
    path: "/islamicguide-64",
  },
  {
    title: "Day 65: Bitcoin & The Abolition of Riba",
    path: "/islamicguide-65",
  },
  {
    title: "Day 66: The Financial Wasatiyyah (moderation) of Bitcoin",
    path: "/islamicguide-66",
  },
  {
    title:
      "Day 67: The New Era of Kitabah al-mal: Examining Bitcoin's Blockchain ",
    path: "/islamicguide-67",
  },
  {
    title: "Day 68: Anti-Harb Money: How Bitcoin Defunds Fiat Wars",
    path: "/islamicguide-68",
  },
  {
    title: "Day 69: Bitcoin & Obedience to the Muslim Ruler",
    path: "/islamicguide-69",
  },

  {
    title: "Day 70: Why Islamic Banking is NOT a solution",
    path: "/islamicguide-70",
  },
];

const IndexIslamicGuide = () => {
  const [visibleItems, setVisibleItems] = useState([]);
  // Add state for hover tracking, matching IndexEconomics
  const [hoveredIndex, setHoveredIndex] = useState(null);
  // Define a custom title text, replacing the TypewriterText logic for simplicity
  // or you would need to import TypewriterText and use it.
  const titleText = "Bitcoin Guide For Muslims";

  useEffect(() => {
    pages.forEach((_, index) => {
      const delay = 50 * index;
      const timeoutId = setTimeout(() => {
        setVisibleItems((prevItems) => [...prevItems, index]);
      }, delay);
      return () => clearTimeout(timeoutId);
    });
  }, []);

  // Define the base style object for all links, matching IndexEconomics
  const baseLinkStyle = {
    fontSize: "18px",
    width: "100%", // Take full width for consistent border/hover area
    padding: "15px 20px", // Increased padding for better visual spacing
    margin: "0", // Remove vertical margin from Link component
    textDecoration: "none", // Remove default underline
    borderBottom: "1px solid #eee", // Light separator line
    color: "black",
    cursor: "pointer",
    textAlign: "left", // Align text to the left for better readability

    // Combined transitions for smooth effects
    transition:
      "color 0.3s ease, background-color 0.3s ease, transform 0.3s ease, opacity 0.5s ease, border-color 0.3s ease",
  };

  // Define the hover style, matching IndexEconomics
  const hoverStyle = {
    backgroundColor: "#f9f9f9", // Very light grey background on hover
    color: "#034d28", // Dark Green text on hover (The primary color from IndexEconomics)
    transform: "translateX(5px)", // Subtle slide-right effect
    borderBottomColor: "#034d28", // Dark Green border on hover
  };

  return (
    <div
      style={{
        width: "95%",

        margin: "40px auto",
        padding: "0", // Remove padding to allow links to touch edges
        backgroundColor: "white",
        border: "2px solid #ccc",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", //
        fontFamily: "Georgia, sans-serif",
        lineHeight: "1.6",
        letterSpacing: "0.3px",
      }}
    >
      <h1
        style={{
          fontSize: "30px",
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "20px",
          marginTop: "20px",
          color: "black",
          padding: "0 20px", // Add padding back to the title, matching IndexEconomics
        }}
      >
        <b>Table of Contents</b>
        <br />

        <TypewriterText
          text={titleText}
          delay={80} // Typing speed for the title
        />
      </h1>
      {pages.map((page, index) => {
        const isVisible = visibleItems.includes(index);
        const isHovered = hoveredIndex === index; // Use the new hover state

        return (
          <Link
            key={index}
            to={page.path}
            // Merge base style, animation style, and hover style, matching IndexEconomics logic
            style={{
              ...baseLinkStyle,
              ...(isVisible
                ? {}
                : { opacity: 0, transform: "translateY(20px)" }), // Animation style
              ...(isHovered ? hoverStyle : {}), // Hover style
            }}
            // Add onMouseEnter and onMouseLeave handlers, matching IndexEconomics
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {page.title}
          </Link>
        );
      })}
    </div>
  );
};

export default IndexIslamicGuide;
